module.exports = __webpack_public_path__ + "img/brain.5fe78372.svg";